import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Grid4: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--grid', 'svg-icon--grid-4')}
    data-icon={icon}
    viewBox="0 0 19 17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g className={s.gridFill} fillRule="evenodd">
      <path d="M0 0h4v5H0zM5 0h4v5H5zM10 0h4v5h-4zM15 0h4v5h-4zM0 6h4v5H0zM5 6h4v5H5zM10 6h4v5h-4zM15 6h4v5h-4zM0 12h4v5H0zM5 12h4v5H5zM10 12h4v5h-4zM15 12h4v5h-4z" />
    </g>
  </svg>
);

export default Grid4;
